import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate, Navigate } from "react-router-dom";

import LayoutAuth from "../layoutAuth";

const WelcomeLayout = ({ authenticated }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isBrandStep =
    location.pathname.startsWith("/welcome/brand") ||
    location.pathname === "/welcome/" ||
    location.pathname === "/welcome";

  useEffect(() => {
    if (!authenticated) {
      navigate("/login/");
    }
  }, [authenticated, navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  if (!isBrandStep) {
    return <Navigate to="/welcome/brand/" replace />;
  }

  return (
    <LayoutAuth
      title="Add your brand"
      subtitle="Add brand details and we'll curate content ideas to your style."
      maxWidthClass="sm:max-w-md"
    >
      <Outlet />
    </LayoutAuth>
  );
};

export default WelcomeLayout;
